<!--
  ~ Copyright (c) 2020 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<kit-container [kitModel]="model"></kit-container>
